// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyDCeo5R_gPjQw-6tqND7rhCnJYI97SFEc4',
  authDomain: 'kei-finance-a203f.firebaseapp.com',
  projectId: 'kei-finance-a203f',
  storageBucket: 'kei-finance-a203f.appspot.com',
  messagingSenderId: '413934819993',
  appId: '1:413934819993:web:9c1cffbcf016b4e2cbf608',
  measurementId: 'G-6PL6T7N7MX',
};
